export const PGLOBALS = {
  BASE_URL: "http://preprodapi.vodafoneplay.in/",
  VIDEO_FORMATS: {
    dash: "application/dash+xml",
    wvm: "application/octet-stream",
    hls: "application/x-mpegURL",
    hlsaes: "application/x-mpegURL"
  }
};
